
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import blogData from "../blogData.json";
import blogBg from "../../../assests/blog/angu (1).png";

const GlobalITStaffingSolutions = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div className="mx-auto px-4 py-12">
      {/* Relative wrapper for positioning */}
      <div className="relative w-full h-[400px] mb-6">
        <img
          src={blogBg}
          className="w-full h-full object-cover opacity-90 rounded-lg"
          alt="Blog Background"
        />

        {/* Centered Text */}
        <div className="absolute inset-0 flex items-center justify-center px-4">
          <h1 className="text-center text-[45px] lg:text-4xl font-recoleta text-white max-w-3xl">
          How Most Companies Use Global IT Staffing Solutions?
          </h1>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4">
      <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
      Many software companies want to outsource services for which they do not have the expertise or experience of the workforce or team available. Global IT Staffing Solutions provides a workforce as per customer needs. We are experts in building cloud-based software products. Our team is on its feet to design and develop as per customer needs. When you are looking forIT Staffing Solutions , look no further.
          </p>
        <div className="text-left">
          <div className="h-12 border-l-2 px-8 border-blue-600">
            <h1 className="font-bold text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">
            Impact on using Global IT Staffing Solutions
            </h1>
          </div>
          <h1 className="font-bold text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">
          Get Profit With Less Money
            </h1>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          ur staffing solutions are cost-optimized, giving a better return on investment with a Simple and optimized recruitment process. We have access to a great talent pool. These people are experts in their area, and they know what they do. Our resources are available round the clock, which provides flexibility and high productivity in return.
          </p>
        

          <h1 className="font-bold text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">
          Mobility at its best and Quick Turnaround
            </h1>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          We also provide IT recruitment services to the customers along with development services. We are a small business firm committed to delivering quality solutions. As an IT staffing company, we provide end to end consulting and software development services with a combination of onsite and offshore delivery models. That is the reason when customers are looking for; an IT staffing company, they approach Global IT staffing Services.
          </p> <h1 className="font-bold text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">
          Get a 100% Success rate with Specialized Talent From All Over The World
            </h1>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          As an IT recruitment company, GITS (Global IT Staffing Solutions) ensures that all talents pass through the pre-screening channel. We have a pre-screening team specializing in software development, testing, databases, IT security, networking and project management. We strive to be the first company with a 100% success rate by researching, building relationships and always providing the right people to make this a success.
          </p> <h1 className="font-bold text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">
          Delivers Quality Resources.
            </h1>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          Global IT staffing takes time and effort to fully understand clients' needs and ensure that the project properly combines experience, technology and culture to meet job requirements. Delivering quality resources is the biggest challenge for an IT staffing company, and we do it every time.
          </p> <h1 className="font-bold text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">
          Saves Time, Cost, And Effort.
            </h1>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          Global IT staffing service is not like services provided by other IT staffing companies; it offers a wide range of skills to accept your contract opportunities. Our consultants can be relocated to meet the needs of your project and are available at your location. We recruit these consultants to review and evaluate their effectiveness for the project and help them get started from day one.
          </p> <h1 className="font-bold text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">
          Saves Time, Cost, And Effort.
            </h1>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          Global IT staffing service is not like services provided by other IT staffing companies; it offers a wide range of skills to accept your contract opportunities. Our consultants can be relocated to meet the needs of your project and are available at your location. We recruit these consultants to review and evaluate their effectiveness for the project and help them get started from day one.
          </p> 
        </div>

        <div className="h-12 border-l-2 px-8 border-blue-600">
            <h1 className="font-bold text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">
            Quick Advantages of Using Global IT staffing Solutions
            </h1>
          </div>
     
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          1. Talented staff
          </p>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-2 lg:mt-2">
          2. Quick turnaround
          </p> <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-2 lg:mt-2">
          3. Industry and department-specific Staff Hiring
          </p> <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-2 lg:mt-2">
          4. Well Configured, onboarding, and maintenance track records
          </p> <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-2 lg:mt-2">
          5. Get high profits with minimal hiring efforts.
          </p>
          <h1 className="font-bold text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">
          Final Thoughts!
            </h1>
            <p>
            Finding the right candidates with relevant skills and expertise to handle all actions at the right time is the most significant benefit. It's clear that most companies are looking for a global IT staffing solution to help their hiring efforts. Nowadays, talent acquisition has become more complex in the staff hiring journey. At TEKIT Solutions, we offer the best IT staffing services with flexible, scalable, and cost-effective staffing solutions to reduce risk and gain more profits. Connect with our staffing solution expert now.
          </p> 
      </div>

    </div>
  );
};

export default GlobalITStaffingSolutions;
